import { MetricRow } from './logger.metric-row';
import { EventRow } from './logger.event-row';
import { InjectionToken } from '@angular/core';
import { ILogger as IShellLogger } from 'shell-models-lib';

export interface ILogger extends IShellLogger {
    initializeLoggingContext(): void;
    log(componentName: string, message: string, properties?: Record<string, string | number>): void;
    error(componentName: string, message: unknown, properties?: Record<string, string| number>): void;
    warn(componentName: string, message: string, properties?: Record<string, string| number>): void;
    logEvent(event: EventRow): void;
    logMetric(metric: MetricRow): void;
    logPageView(): void;
    flush(): void;
    debug(componentName: string, message: string): void;
}

export const I_LOGGER = new InjectionToken<ILogger>('ILogger');
